// extracted by mini-css-extract-plugin
module.exports = {"flipCard":"flipCard_flipCard__1mAJZ"};